<template>
    <div>
        <card class="cursor-pointer mb-2">
            <div class="p-3 text-center pestroutes"
                 :class="{'active' : integrated}"
                 @click="open()">
                <img class="p-3" src="/img/pestroutes-logo.png" style="height: 60px"/>
            </div>
        </card>
        <modal ref="modal"
               size="lg"
               @hide="close()"
               :scrollable="true"
               :has-footer="false">

            <template slot="title">Pest Routes Integration</template>
            <transition name="fade-in-down">
                <div v-if="integrated">
                    <div v-if="!editMode">
                        <div v-if="!logsMode">
                            <div class="alert alert-success">
                                <div>
                                    <span> Your credentials have been verified! </span>

                                    <button-loading type="button" class="btn btn-danger ml-2 float-right"
                                                    :loading="form.submitting"
                                                    @click="removePestroutesCredentials">
                                        Remove Api Credentials
                                    </button-loading>
                                </div>
                            </div>

                            <integration-connection-list
                            :location="location"
                            :campaigns="campaigns"
                            :refreshConnectionList="refreshConnectionList"
                            integrationType="pestroutes"
                            @startEditMode="startEdit"
                            @exitEditMode="exitEdit"
                            @loadLogs="loadLogs"
                            >
                            </integration-connection-list>
                        </div>
                        <div v-if="logsMode">
                            <card-spinner v-if="loadingLogs"></card-spinner>
                            <div v-else>
                                <div style="max-height: calc(100vh - 300px); overflow: auto;">
                                    <table class="table table-hover table-striped table-light table-sm mb-0">
                                        <thead>
                                        <tr>
                                            <th class="pl-3">Result</th>
                                            <th>Customer ID</th>
                                            <th>Customer Name</th>
                                            <th>Serviced By ID</th>
                                            <th>Office ID</th>
                                            <th>Completed Date</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <template v-for="(log,index) in logs.data">
                                            <tr>
                                                <td>
                                              <span v-if="log.result_status !== 'success'"
                                                    class="badge px-2 py-1 text-uppercase"
                                                    data-toggle="collapse"
                                                    :data-target="`#accordion${index}`"
                                                    :class="statusClassOf(log)"
                                                    v-tooltip="tooltipFor(log)">
                                                  {{ log.result_status }}
                                                  <i class="fa fa-chevron-down"></i>
                                              </span>
                                                    <span v-else class="badge px-2 py-1 text-uppercase"
                                                          :class="statusClassOf(log)"
                                                          v-tooltip="tooltipFor(log)">
                                                  {{ log.result_status }}
                                              </span>
                                                </td>
                                                <td>{{log.customer_id}}</td>
                                                <td>{{log.customer_name}}</td>
                                                <td>{{log.serviced_by_id}}</td>
                                                <td>{{log.office_id}}</td>
                                                <td>{{log.date_completed}}</td>
                                            </tr>
                                            <tr>
                                                <td colspan="8" class="p-0">
                                                    <div :id="`accordion${index}`" class="collapse p-1">
                                                        <pre><code>{{ log.errors }}</code></pre>
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                        </tbody>
                                    </table>
                                </div>
                                <pagination class="mb-0 mt-3" :meta="logs.meta"
                                            :links="logs.links"
                                            @page="fetchAppointmentLogs"></pagination>
                                <div class="text-right">
                                    <button @click="exitLogsMode()" class="btn btn-default mt-2">Back</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="editMode">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group" :class="{'is-invalid': form.errors.has('campaign_id')}">
                                    <label>Campaign</label>
                                    <select class="form-control" v-model="form.campaign_id">
                                        <option :value="null"></option>
                                        <option v-for="campaign in campaigns"
                                                :key="campaign.id" :value="campaign.id">
                                            {{ campaign.name }}
                                        </option>
                                    </select>
                                    <p v-if="form.errors.has('campaign_id')" class="invalid-feedback">
                                        {{ form.errors.get('campaign_id') }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group"
                                     :class="{'is-invalid': form.errors.has('sync_at')}">
                                    <div class="d-flex justify-between">
                                        <label>Sync at</label>
                                        <small class="ml-auto float-right text-muted" style="padding-top: 4px">
                                            Server Time:
                                            <server-time
                                                class="ml-1"
                                                format="hh:mm:ss a"
                                            />
                                        </small>
                                    </div>

                                    <vue-ctk-date-time-picker
                                        v-model="form.sync_at"
                                        label="Select time"
                                        :no-label="true"
                                        format="hh:mm a"
                                        formatted="hh:mm a"
                                        color="#0374D7"
                                        :minute-interval="1"
                                        :only-time="true"
                                    />
                                    <p v-if="form.errors.has('sync_at')" class="invalid-feedback">
                                        {{ form.errors.get('sync_at') }}
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group"
                                     :class="{'is-invalid': form.errors.has('send_at')}">
                                    <label>Send invites at</label>
                                    <vue-ctk-date-time-picker
                                        v-model="form.send_at"
                                        label="Select time"
                                        :no-label="true"
                                        color="#0374D7"
                                        format="hh:mm a"
                                        formatted="hh:mm a"
                                        :without-header="true"
                                        :minute-interval="15"
                                        :only-time="true"
                                    />
                                    <p v-if="form.errors.has('send_at')" class="invalid-feedback">
                                        {{ form.errors.get('send_at') }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <hr/>
                        <integration-form-custom-id-selector
                        idType="Office"
                        :selectedIds="form.office_ids"
                        @addId="addOfficeId"
                        @removeIdIndex="removeOfficeId"
                        />
                        <hr/>
                        <div v-if="form.office_ids.length" class="form-group"
                             :class="{'is-invalid': form.errors.has('serviced_by_ids')}">
                            <p v-if="form.errors.has('serviced_by_ids')" class="invalid-feedback">
                                {{ form.errors.get('serviced_by_ids') }}
                            </p>
                            <div v-if="showEmployeeRefreshOption" class="mb-4 text-right">
                                <button type="button" class="btn btn-success" @click="getEmployeeList">
                                    Search For Available Employees
                                </button>
                            </div>
                            <integration-form-checkbox-selectors
                                label="(Employee) Serviced By"
                                :loading="loading"
                                fieldName="servicedBy"
                                :fieldOptions="form.employees"
                                :fieldSelection="form.serviced_by_ids"
                                :displayOptionProperties="employeePropertyArray"
                                @updateSelection="updateServicedBy"
                                />
                        </div>
                    </div>
                </div>
            </transition>
            <transition name="fade-in-down">
                <div v-if="!loading">
                    <div v-if="!integrated">
                        <div v-if="!createNewInstance">
                            <div class="mb-4 text-right">
                                <button type="button" class="btn btn-primary" @click="createNewInstance = true">
                                    Add New Instance/Connection
                                </button>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group" :class="{'is-invalid': form.errors.has('pestroutes_instance_id')}">
                                        <label>Available Instances/Connections</label>
                                        <select class="form-control" v-model="form.pestroutes_instance_id">
                                            <option :value="null"></option>
                                            <option v-for="instance in instances"
                                                    :key="instance.id" :value="instance.id">
                                               {{ instance.name }} - Subdomain: {{ instance.pestroutes_subdomain }}
                                            </option>
                                        </select>
                                        <p v-if="form.errors.has('pestroutes_instance_id')" class="invalid-feedback">
                                            {{ form.errors.get('pestroutes_instance_id') }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="mb-4 text-right" v-if="instances.length">
                                <button type="button" class="btn btn-primary" @click="createNewInstance = false">
                                     Use Existing Instance/Connection
                                </button>
                            </div>
                            <div class="form-row">
                                <div class="col-md-12">
                                    <input-text
                                        label="Instance/Connection Name"
                                        field="name"
                                        v-model="form.name"
                                        :form="form"
                                    />
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-md-12">
                                    <input-text
                                        label="authenticationKey"
                                        field="pestroutes_key"
                                        v-model="form.pestroutes_key"
                                        :form="form"
                                    />
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-md-12">
                                    <input-text
                                        label="authenticationToken"
                                        field="pestroutes_token"
                                        v-model="form.pestroutes_token"
                                        :form="form"
                                    />
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-md-12">
                                    <input-text
                                        label="subdomain"
                                        field="pestroutes_subdomain"
                                        v-model="form.pestroutes_subdomain"
                                        :form="form"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </transition>
            <card-spinner
                v-if="loading"
                style="height:200px"
            />
            <div v-if="!integrated">
                <div class="modal-footer mt-2 pr-0 pb-0 pl-0">
                    <button class="btn btn-default"
                            type="button"
                            data-dismiss="modal"
                            @click="close()">
                        Close
                    </button>
                    <button-loading type="button" class="btn btn-primary ml-2"
                                    :loading="form.submitting"
                                    @click="verifyIntegration">
                        Save
                    </button-loading>
                </div>
            </div>
            <div v-if="editMode">
                <div class="modal-footer mt-2 pr-0 pb-0 pl-0">
                    <button class="btn btn-default"
                            type="button"
                            data-dismiss="modal"
                            @click="exitEdit()">
                        Close
                    </button>
                    <button-loading type="button" class="btn btn-primary ml-2"
                                    :loading="form.submitting"
                                    @click="saveIntegration">
                        Save
                    </button-loading>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
    import axios                            from 'axios';
    import VueCtkDateTimePicker             from 'vue-ctk-date-time-picker';
    import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
    import IntegrationFormCheckboxSelectors from "./IntegrationFormCheckboxSelectors";

    export default {
        props     : {
            location: {required: true}
        },
        components: {
            IntegrationFormCheckboxSelectors,
            VueCtkDateTimePicker
        },
        data      : () => ({
            form: new Form({}),
            loading: false,
            editMode: false,
            campaigns: [],
            instances: [],
            createNewInstance: false,
            recentlyIntegrated: false,
            officeId: '',
            employees: [],
            employeePropertyArray:[
              'name', 'office_id'
            ],
            loadingLogs: false,
            logsMode: false,
            logs: [],
            query: null,
            selectedConnection: null,
            refreshConnectionList: false,
            showEmployeeRefreshOption: true
        }),
        computed: {
            integrated() {
                let isIntegrated = !!this.location.pestroutes_instance_id;
                if(this.recentlyIntegrated){
                    isIntegrated = true;
                }
                return isIntegrated;
            }
        },
        watch     : {
            location: {
                immediate: true,
                handler() {
                    this.form = new Form({
                        local_location_id: this.location.id,
                        pestroutes_key    : null,
                        pestroutes_token  : null,
                        pestroutes_subdomain : null,
                        pestroutes_instance_id : null,
                        name                   : null,
                    });
                }
            }
        },
        methods: {
            async open() {
                this.$refs.modal.open();
                this.$emit('show', true);
                if (!this.integrated) {
                    await this.fetchInstances();
                }else{
                    this.getPestrouteIntegrations();
                }
                this.campaigns = this.location.campaigns;
                this.loading   = false;
            },

            close() {
                this.$emit('hide');
                this.$emit('save-integration', this.location.id);
                this.recentlyIntegrated = false;
                this.loading = false;
                this.logsMode           = false;
                this.selectedConnection = null;
                this.exitEdit();
            },
            verifyIntegration() {
                this.loading = true;
                if(!this.createNewInstance){
                    this.location_update();
                }else{
                    this.form.post('pestroutes/authenticate').then(({data}) => {
                        if(data.is_authenticated){
                            this.location_update();
                        }else{
                            swal.fire({
                                title: 'Failed To Authenticate',
                                type: 'warning',
                            });
                            this.loading = false;
                        }
                    }).catch(error => console.error(error));;
                }
            },

            location_update() {
                this.form.put('pestroutes/' + this.location.id + '/instance-update').then(({data}) => {
                    swal.fire({
                        title: 'Connection Confirmed!',
                        type: 'success',
                    });
                    this.recentlyIntegrated = true;
                }).catch(error => console.error(error)).finally(() => {
                    this.loading = false;
                });
            },

            async removePestroutesCredentials() {
                const result = await this.$confirmDialog();
                if (!result) return;
                this.loading = true;
                this.form.put('pestroutes/' + this.location.id + '/instance-remove').then(({data}) => {
                    this.loading = false;
                    this.$emit('save-integration', this.location.id);
                    swal.fire({
                        title: 'Pest Routes Credentials Removed',
                        type: 'warning',
                    });
                    this.$refs.modal.close();
                }).catch(error => console.error(error));
            },

            loadLogs(connection) {
                this.selectedConnection = connection;
                this.logsMode = true;
                this.fetchAppointmentLogs();
            },
            startEdit(connection) {
                this.selectedConnection = connection;
                this.form = new Form({
                    id: connection ? connection.id : null,
                    campaign_id : connection ? connection.campaign_id : null,
                    sync_at : connection ? connection.sync_at : '12:00 am',
                    send_at : connection ? connection.send_at : '12:00 am',
                    location_id: this.location.id,
                    office_ids: connection ? connection.offices : [],
                    employees: connection ? connection.employees : [],
                    serviced_by_ids: connection ? connection.serviced_by_ids : [],
                });
                this.editMode = true;
            },
            exitEdit() {
                this.selectedConnection = null;
                this.editMode = false;
                this.form     = new Form({});
            },
            async fetchInstances() {
                await this.$http.get('pestroutes/' + this.location.id + '/instance-list').then(({data}) => {
                    this.instances = data;
                    this.createNewInstance = !this.instances.length;
                }).catch(error => console.error(error));
            },
            saveIntegration(){
                this.loading = true;
                try{
                    if(this.form.id){
                        this.form.put('pestroutes/updateIntegration')
                            .then(() => {
                                this.getPestrouteIntegrations();
                                swal.fire({
                                    title: 'Saved',
                                    type: 'success',
                                });
                                this.editMode = false;
                            });
                    }else{
                        this.form.post('pestroutes/createIntegration')
                            .then(() => {
                                this.getPestrouteIntegrations();
                                swal.fire({
                                    title: 'Saved',
                                    type: 'success',
                                });
                                this.editMode = false;
                            });
                    }

                } catch (e) {
                    console.error(e);
                } finally {
                    this.loading = false;
                }
            },

            addOfficeId(officeId) {
                this.form.office_ids.push(officeId);
                this.showEmployeeRefreshOption = true;
            },
            removeOfficeId(officeIdIndex) {
                this.form.office_ids.splice(officeIdIndex, 1);
                if(!this.form.office_ids.length) {
                    this.form.serviced_by_ids = [];
                }
            },
            updateServicedBy(servicedByIds) {
                this.form.serviced_by_ids = servicedByIds;
            },

            getPestrouteIntegrations() {
                this.refreshConnectionList = true;
            },

            async getEmployeeList() {
                await this.form.post('pestroutes/' + this.location.id + '/employee-list').then(({data}) => {
                    this.employees = data;
                    this.form.employees = data;
                    this.form.serviced_by_ids = [];
                    this.showEmployeeRefreshOption = false;
                }).catch(error => console.error(error));
            },

            async loadLogs(connection) {
                this.selectedConnection = connection;
                this.logsMode = true;
                await this.fetchAppointmentLogs();
            },

            async fetchAppointmentLogs(page = 1){
                try {
                    this.loadingLogs = true;
                    const params     = {page, search: this.query};
                    const {data: logs} = await this.$http.get(`/pestroutes/${this.selectedConnection.id}/getAppointmentLogs`, {params});
                    this.logs = logs;
                } catch (e) {
                    console.error('Unable to load logs: ', e);
                } finally {
                    this.loadingLogs = false;
                }
            },
            exitLogsMode () {
                this.logsMode = false;
            },
            statusClassOf(appointment) {
                return {
                    'badge-success': appointment.result_status === 'success',
                    'has-more badge-danger cursor-pointer': appointment.result_status === 'failed',
                    'has-more badge-secondary cursor-pointer': appointment.result_status === 'filter-off',
                    'has-more badge-danger cursor-pointer': appointment.result_status === 'customer-not-found',
                };
            },

            tooltipFor(appointment) {
                const errors = appointment.errors;
                return appointment.errors && appointment.errors.length ?
                    {title: errors && errors.length && errors[0]} :
                    null;
            },

        }
    }
</script>


<style lang="scss" scoped>
    legend {
        font-size: 1rem;
    }

    .table th, .table td {
        white-space: nowrap;
        font-size: small;
    }

    .pestroutes {
        min-height: 100px;
        filter: grayscale(100%);
        background-repeat: no-repeat;
        background-size: contain;
        opacity: 0.6;
        background-position-y: center;
        background-position-x: center;

        &:hover {
            filter: grayscale(0%);
            opacity: 0.8;
        }

        &.active {
            filter: grayscale(0%);
            opacity: 1;
        }
    }

    .is-invalid {
        .invalid-feedback {
            display: block;
        }
    }

</style>


<style lang="scss">
    .date-time-picker {
        .field-input {
            color: #6e7d87;
            font-weight: 600;
            font-size: 16px;
            font-family: "open sans", Whitney, Lato, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
            border: 1px solid #b0b9bf !important;

            &:focus {
                border-color: #5db2fd;
                box-shadow: 0 0 0 0.2rem rgba(3, 116, 215, .25);
            }
        }
    }

    .alert span {
        vertical-align: middle;
        line-height:normal;
    }

    .alert > div {
        line-height: 34px;
    }
</style>
